import styles from './igaming.module.css'

export function RuntimeImpact({ impact }) {
  return (
    <div className={styles.impactPanel}>
      <div className={styles.impactLine}>
        <span>{impact.status}</span>
        <span>{impact.count} game{impact.count === 1 ? '' : 's'}</span>
        {impact.rules.length ? <span>Uses {impact.rules.slice(0, 2).join(', ')}</span> : null}
      </div>
      {impact.topGames.length ? (
        <div className={styles.impactCodes}>
          {impact.topGames.map((code) => <code key={code}>{code}</code>)}
        </div>
      ) : null}
      {impact.warnings.length ? (
        <ul className={styles.impactWarnings}>
          {impact.warnings.map((warning) => <li key={warning}>{warning}</li>)}
        </ul>
      ) : null}
    </div>
  )
}
